export default __webpack_public_path__ + "32ccbdff2ea10853c22c46e5698a4294.ttf";